import { parseableSearchSchema, stringParamWithDefault } from "@crm/effect/schema/search";
import { Schema } from "effect";

export const levelChangesSearchSchema = parseableSearchSchema(
  Schema.Struct({
    coach: stringParamWithDefault("all"),
  }),
);

export type LevelChangesSearch = Schema.Schema.Type<typeof levelChangesSearchSchema>;
